import React from 'react';
import PropTypes from 'prop-types';
import { IngredientCard } from '../IngredientCard';
import { CardContainer, IngredientBody } from './styles';

export const RecipeCarouselIngredient = ({ name, image, description }) => (
  <CardContainer>
    <IngredientCard name={name} image={image}>
      <IngredientBody>{description}</IngredientBody>
    </IngredientCard>
  </CardContainer>
);

RecipeCarouselIngredient.propTypes = {
  name: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  description: PropTypes.node.isRequired,
};
